import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from '../axios'

const initialState = {
    // step: 0,
    step: 1,
    PersonalDetails:
    {
        fullName: "",
        email: "",
        phone: "",
        userPhone: "",
        countryCode: "",
        address: "",
        identityFront: "",
        identityBack: ""
    },
    carDetails: {
        carMake: "",
        carModel: "",
        carType: "",
        manufactureYr: "",
        registrationNum: "",
        seat: "",
        mileage: "",
        fuelType: "",
        motor: "",
        speed: "",
        power: "",
        carFeature: "",
        carLocation: "",
        location: "",
        carFrontImg: '',
        carBackImg: "",
        carLeftImg: "",
        carRightImg: '',
        numberPlateImg: '',
        carSeatsImg: "",
        carInteriorImg: "",
        carDashboardImg: "",
        carChassisImg: "",
        gpsAvaiblity: false,
        gpsPayment: 0,
        driverToggle:false,
    },
    driverDetails: {
        fullName: "",
        age: "",
        phone: "",
        driverPhoneNumber: "",
        driverCountryCode: "",
        email: "",
        driverRent: "",
        IDfront: "",
        IDback: "",
        licenceImg: "",
        licenceIssueDate: "",
        licenceExpiryDate: "",
        withDriver: false,
    },
    carInsurance: {
        pricePerDay: "",
        companyName: "",
        policyNumber: "",
        expiryDate: "",
        // insuranceAvailable: false,
        insuranceAvailable: true,
        diskImage:"",
    },
    carMakeList: [],
    carModalList: [],
    carTypeList: [],
    carFeaturesList: [],
    addCarData: [],
    editCarResponse: {},
    editCarID: "",
    carImagesResponse:{},
}

const config = {
    headers: {
        'Content-Type': 'multipart/form-data',
        "key": "KwachaRides-api-secret-key"
    }
}

export const getCarMake = createAsyncThunk(
    "getCarMake",
    async () => {
        try {
            const response = await axios.get('/car/fetchCarMaker', config)
            return response.data;
        } catch (error) {
            return error.response.data.errors
        }
    });
export const carUploadImages = createAsyncThunk(
    "carUploadImages",
    async (data) => {
        try {
            const response = await axios.post('/car/uploadImage',data, config)
            return response.data;
        } catch (error) {
            return error.response.data.errors
        }
    });

export const getCarModal = createAsyncThunk(
    "getCarModal",
    async (data) => {
        try {
            const response = await axios.get(`/car/getModelNames?carMakerId=${data}`, config)
            return response.data;
        } catch (error) {
            return error.response.data.errors
        }
    });

export const getCarType = createAsyncThunk(
    "getCarType",
    async (data) => {
        try {
            const response = await axios.get(`category/getCategories`, config)
            return response.data;
        } catch (error) {
            return error.response.data.errors
        }
    });

export const getCarFeatures = createAsyncThunk(
    "getCarFeatures",
    async (data) => {
        try {
            const response = await axios.get(`feature/fetchFeature`, config)
            return response.data;
        } catch (error) {
            return error.response.data.errors
        }
    });

export const addCar = createAsyncThunk(
    "addCar",
    async (info) => {
        try {
            const response = await axios.post(`car/createCar`, info?.data)
            // const response = await axios.post(`car/createCarWeb`, info?.data)
            return response;
        } catch (error) {
            return error.response.data.errors
        }
    });

export const editCar = createAsyncThunk(
    "editCar",
    async (info) => {
        try {
            const response = await axios.post(`car/editCar`, info?.data)
            return response;
        } catch (error) {
            return error.response.data.errors
        }
    });

const formSlice = createSlice({
    name: "form",
    initialState,
    reducers: {
        increaseStep(state) {
            state.step = state.step + 1
        },
        decreaseStep(state) {
            state.step = state.step - 1
        },
        storePersonalDetails(state, action) {
            state.PersonalDetails = action?.payload
        },
        storeCarDetails(state, action) {
            state.carDetails = action?.payload
        },
        storeDriverDetails(state, action) {
            state.driverDetails = action?.payload
        },
        storeCarInsurance(state, action) {
            state.carInsurance = action?.payload
        },
        storeLoaction(state, action) {
            state.location = action?.payload
        },
        // cleanData(state) {
        //     state.PersonalDetails = {};
        //     state.step = 0;
        //     state.addCarData = [];
        //     state.carInsurance = {};
        //     state.driverDetails = {};
        //     state.carDetails = {};
        // }
        cleanData(state) {
            state.PersonalDetails = {
                fullName: "",
                email: "",
                phone: "",
                address: "",
                identityFront: "",
                identityBack: ""
            };
            state.carDetails = {
                carMake: "",
                carModel: "",
                carType: "",
                manufactureYr: "",
                registrationNum: "",
                seat: "",
                mileage: "",
                fuelType: "",
                motor: "",
                speed: "",
                power: "",
                carFeature: "",
                carLocation: "",
                location: "",
                carFrontImg: '',
                carBackImg: "",
                carLeftImg: "",
                carRightImg: '',
                numberPlateImg: '',
                gpsAvaiblity: false,
                driverToggle: false,
                gpsPayment: 0
            };
            state.driverDetails = {
                fullName: "",
                age: "",
                phone: "",
                email: "",
                driverRent: "",
                IDfront: "",
                IDback: "",
                licenceImg: "",
                licenceIssueDate: "",
                licenceExpiryDate: "",
                withDriver: false,
            };
            state.carInsurance = {
                pricePerDay: "",
                companyName: "",
                policyNumber: "",
                expiryDate: "",
                insuranceAvailable: true,
            };
            // state.step = 0;
            state.step = 1;
            state.addCarData = [];
        },

        cleanAddCarData(state) {
            state.addCarData = [];
        },
        cleanLoaction(state) {
            state.location = ""
        },
        setEditCarID: (state, action) => {
            state.editCarID = action.payload
        },
        clearEditCarID: (state) => {
            state.editCarID = ""
            state.editCarResponse = ""
        },
        clearCarModalList:(state)=>{
            state.carModalList = [];
        },
        setCarImagesResponse:(state,action)=>{
            state.carImagesResponse={...state.carImagesResponse,...action.payload}
        },
        clearCarImagesResponse:(state)=>{
            state.carImagesResponse={};
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getCarMake.fulfilled, (state, action) => {
                state.carMakeList = action?.payload?.data
            })
            .addCase(getCarModal.fulfilled, (state, action) => {
                state.carModalList = action?.payload?.data
            })
            .addCase(getCarType.fulfilled, (state, action) => {
                state.carTypeList = action?.payload?.data
            })
            .addCase(getCarFeatures.fulfilled, (state, action) => {
                state.carFeaturesList = action?.payload?.data
            })
            .addCase(addCar.pending, (state, action) => {
                // state.addCarData = "pending"
            })
            .addCase(addCar.fulfilled, (state, action) => {
                state.addCarData = action?.payload?.data
            })
            .addCase(addCar.rejected, (state, action) => {
                // state.addCarData = "rejected"
            })
            .addCase(editCar.fulfilled, (state, action) => {
                state.editCarResponse = action?.payload?.data
            })
            .addCase(editCar.rejected, (state, action) => {
                // state.addCarData = "rejected"
            })

    },
})

export const { decreaseStep, increaseStep, storePersonalDetails, storeCarDetails, storeDriverDetails, storeCarInsurance, storeLoaction, cleanData, cleanLoaction, clearEditCarID, setEditCarID,clearCarModalList,cleanAddCarData ,setCarImagesResponse,clearCarImagesResponse} = formSlice.actions;
export default formSlice.reducer